import React, { useState, useRef, useEffect } from "react";
import "./modal.scss";
import axios from "axios";
import Cookies from "js-cookie";
import "react-multi-date-picker/styles/layouts/prime.css";
// import { connection } from "utils/apiConnection.ts";
import Select, { StylesConfig } from "react-select";
// import useInput from "hooks/use-input";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import toast from "react-hot-toast";
import { isString } from "lodash";
import ReactTooltip from "react-tooltip";
import { RiDeleteBin5Line } from "react-icons/ri";
import useAxios from "../../../services/useAxios";
import { NumericFormat, PatternFormat } from "react-number-format";
import { Col, Row } from "react-bootstrap";
import { MdFileDownloadDone } from "react-icons/md";
import { useImmer } from "use-immer";
import MapIR from "../../address/MapIR.jsx";
function EditSupplier({
  setUpdater,
  setIsLoading,
  updater,
  otherInfo,
  setOtherInfo,
  allLeader,
  allProductTags,
  editModalData,
  customers
}) {
  console.log("xxxx", otherInfo);
  // نقشه
  const [address, setAddress] = useState();
  // const auth = useContext(AuthenticationContext);
  const [Nextstep, setNextstep] = useState(true);
  const [location, setLocation] = useState({
    lngLat: { lng: "", lat: "" }
  });
  // نقشه

  useEffect(() => {
    setOtherInfo({
      ...otherInfo,
      fullname: "",
      user_mobile: ""
    });
  }, []);
  const [listInfoBank, setListInfoBank] = useState([
    // {
    //   numberCart: "1234567890123456",
    //   nameBank: "قرض الحسنه مهرایران",
    //   cartType: "نقدی",
    //   Shebanumber: "12300007123000989001",
    //   accountNumber: "12309856563439954",
    //   //status: "فعال ",
    // },
  ]);
  const [campian, setCampain] = useState([]);
  const pattern = /^09\d{9}$/;
  const tellPattern = /^0\d{10}$/;
  const patternNumbercart = /^\d{16}$/;
  const patternNumberAcount = /^\d{13}$/;
  const patternSheba = /^\d{24}$/;
  //اطلاعت بانکی
  const [cartType, setCartType] = useState([
    { value: " 0", label: "نقدی" },
    { value: "1", label: "اعتباری" }
  ]);

  const [infoBank, setInfoBank] = useState({
    numberCart: "",
    nameBank: "",
    Shebanumber: "",
    accountNumber: ""
  });
  const bankJSON = JSON.stringify(infoBank);

  const [infoBankValid, setInfoBankValid] = useImmer({
    numberCart: true,
    nameBank: true,
    Shebanumber: true
  });

  const InfoBankValidation = () => {
    let cardNumber = infoBank.numberCart
      .replaceAll("-", "")
      .replaceAll(/\s/g, "");
    let sheba = infoBank.Shebanumber.replaceAll("IR", "").replaceAll(/\s/g, "");

    const validation = [
      patternNumbercart.test(cardNumber),
      infoBank.nameBank != "",
      patternSheba.test(sheba)
    ];

    setInfoBankValid(draft => {
      draft.numberCart = validation[0];
      draft.nameBank = validation[1];
      draft.Shebanumber = validation[2];
    });

    return validation[0] && validation[1] && validation[2];
  };

  const RemoveInfoBank = index => {
    let newArray = listInfoBank.filter((value, index2, array) => {
      if (index == index2) {
        return false;
      } else {
        return true;
      }
    });
    setListInfoBank(newArray);
  };
  //   const title = useInput((value) => value.trim() !== "");
  const [filterCat, setFilterCat] = useState();
  const [update, setUpdate] = useState(false);
  const [disabledBtn, setDisabledBtn] = useState(false);
  const inputElement = useRef();
  const { loadingEdit, execute: editApi } = useAxios(
    "superadminapi/edit_supplier"
  );
  console.log("object **", otherInfo);
  function postHandler(otherInfo) {
    setIsLoading(true);
    let myFormData = new FormData();
    let usertoken = Cookies.get("token");
    let line_idsj = otherInfo?.line_ids.map(value => value.value).join(",");
    let xd = otherInfo?.main_admin_uid;
    if (xd == "-1") {
      myFormData.append("fullname", otherInfo?.fullname);
      myFormData.append("mobile_admin", otherInfo?.user_mobile);
    } else {
      myFormData.append("main_admin_uid", otherInfo?.main_admin_uid);
    }

    if (otherInfo?.title.trim() === "") {
      toast.error("نام    را وارد نمایید");
      return null;
    }
    if (otherInfo?.main_cat === "-1") {
      toast.error("دسته بندی    را وارد نمایید");
      return null;
    }
    if (otherInfo?.main_admin_uid.length == 0) {
      toast.error("کاربر را وارد نمایید");
      return null;
    }
    if (
      otherInfo?.main_admin_uid.value == "-1" &&
      otherInfo?.user_mobile == ""
    ) {
      toast.error("موبایل کاربر را وارد کنید");
      return null;
    }
    setDisabledBtn(true);
    if (otherInfo.logo_file_id === undefined) otherInfo.logo_file_id = "";
    myFormData.append("supplier_id", otherInfo?.suppliers__id);
    !isString(otherInfo?.logo_file_id) &&
      myFormData.append("cover_file_id", otherInfo?.logo_file_id);
    !isString(otherInfo?.cover_file_id) &&
      myFormData.append("logo_file_id", otherInfo?.cover_file_id);
    console.log(
      "object ****",
      !isString(otherInfo?.cover_file_id),
      !isString(otherInfo?.logo_file_id),
      otherInfo
    );
    myFormData.append("usertoken", usertoken ? usertoken : "-1");
    myFormData.append("description", otherInfo?.description);
    myFormData.append("main_cat", otherInfo?.main_cat);
    myFormData.append("tell1", otherInfo?.tell1);
    myFormData.append("tell2", otherInfo?.tell2);
    myFormData.append("email", otherInfo?.email);
    myFormData.append("mobile", otherInfo?.mobile);
    myFormData.append("start_hour", otherInfo?.start_hour);
    myFormData.append("start_min", otherInfo?.start_min);
    myFormData.append("finish_hour", otherInfo?.finish_hour);
    myFormData.append("min_order_amount", otherInfo?.min_order_amount);
    myFormData.append("finish_min", otherInfo?.finish_min);
    myFormData.append("title", otherInfo?.title);
    myFormData.append("line_ids", line_idsj);
    myFormData.append("address", otherInfo?.address);
    myFormData.append("site", otherInfo?.site);
    myFormData.append("instagram", otherInfo?.instagram);
    myFormData.append("bank_info", JSON.stringify(listInfoBank));

    // axios
    //   .post(
    //     "http://old-sabadib.tatdemo.ir/superadminapi/edit_supplier",
    //     myFormData
    //   )
    // --------
    editApi(myFormData).then(res => {
      if (res.status === 1) {
        setDisabledBtn(false);
        toast.success("اطلاعات با موفقیت ویرایش شد!");
        setIsLoading(false);
        setUpdater(!updater);
        inputElement.current.click();
        setDisplayStatusUser("d-none");
        if (otherInfo?.fullname != "") {
          setOtherInfo({
            ...otherInfo,
            fullname: "",
            user_mobile: ""
          });
        }
      } else {
        toast.error("خطا در ویرایش اطلاعات!");

        setIsLoading(false);
        setDisabledBtn(false);
      }
    });
  }

  function inputChangeHandler(event) {
    setOtherInfo({ ...otherInfo, [event.target.name]: event.target.value });
  }

  const changeHandlerImg = e => {
    console.log("object ** e");
    setOtherInfo({ ...otherInfo, [e.target.name]: e.target.files[0] });
  };

  function handleChange(event) {
    switch (event.target.name) {
      case "numberCart":
        console.log(event.target.value.replace(" ", ""));
        break;
      default:
    }

    setOtherInfo({
      ...otherInfo,
      [event.target.name]: removeCommas(event.target.value)
    });
  }

  const changeHandler = (names, value) => {
    if (names == "start") {
      setOtherInfo(prev => {
        return {
          ...prev,
          start_hour: value.split(":")[0],
          start_min: value.split(":")[1]
        };
      });
    } else if (names == "finish") {
      setOtherInfo(prev => {
        return {
          ...prev,
          finish_hour: value.split(":")[0],
          finish_min: value.split(":")[1]
        };
      });
    }
  };
  const inputRef = useRef();

  const translateUserToReactSelect = (arrayValue, reverse) => {
    let after = [];
    if (reverse) {
      // react select to api
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        obj.fullname = arrayValue[index].label;
        obj.id = arrayValue[index].value;
        after.push(obj);
      }
    } else {
      // api to react select
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        obj.label = arrayValue[index].fullname;
        obj.value = arrayValue[index].id;

        after.push(obj);
      }
    }

    return after;
  };
  const translateLinesToReactSelect = (arrayValue, reverse) => {
    let after = [];
    if (reverse) {
      // react select to api
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        obj.title = arrayValue[index].label;
        obj.id = arrayValue[index].value;
        after.push(obj);
      }
    } else {
      // api to react select
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        obj.label = arrayValue[index].title;
        obj.value = arrayValue[index].id;

        after.push(obj);
      }
    }

    return after;
  };
  const { loading, execute: getAddEditSupplierDataApi } = useAxios(
    "superadminapi/get_add_suppliers_data"
  );
  const [user, setuser] = useState([]);
  useEffect(() => {
    getAddEditSupplierDataApi().then(data => {
      setuser(prev => {
        return [
          { fullname: "ثبت کاربر جدید", id: "-1" },
          ...data.user_for_admin
        ];
      });
    });
  }, [updater]);
  const userOptions = translateUserToReactSelect(user, false);
  const [displayStatusUser, setDisplayStatusUser] = useState("d-none");
  const changeHandleraTags = option => {
    setOtherInfo(prev => {
      let temp = { ...prev };
      temp.line_ids = option;
      return { ...temp };
    });
  };

  function inputChangeHandlerDaste(event) {
    setOtherInfo({ ...otherInfo, [event.target.name]: event.target.value });
    setFilterCat(event.target.value);
  }

  const test = allProductTags.filter(
    item => item.parent_line_id == 0
    // {
    //   if (item.main_cat == otherInfo.main_cat && item.parent_line_id == 0) {
    //     return item;
    //   }
    // }
  );

  useEffect(() => {
    otherInfo?.bank_info != "" &&
      setListInfoBank(JSON.parse(otherInfo?.bank_info));
    setInfoBankValid(draft => {
      draft.numberCart = true;
      draft.nameBank = true;
      draft.Shebanumber = true;
    });

    setValid({
      ...valid,
      title: true,
      mobile: true,
      tell1: true,
      tell2: true,
      user_mobile: true
    });
  }, [otherInfo]);

  const [valid, setValid] = useState({
    title: true,
    tell1: true,
    tell2: true,
    mobile: true,
    user_mobile: true
  });

  const validate = () => {
    const validation = [
      otherInfo?.title != "",
      pattern.test(otherInfo?.mobile) && otherInfo?.mobile != "",
      true,
      true,
      // tellPattern.test(otherInfo?.tell1) && otherInfo?.tell1 != "",
      // otherInfo?.tell2 == ""
      //   ? true
      //   : tellPattern.test(otherInfo?.tell2) && otherInfo?.tell2 != "",
      otherInfo?.main_admin_uid.value != "-1"
        ? true
        : pattern.test(otherInfo?.user_mobile) && otherInfo?.user_mobile != ""
    ];

    setValid({
      ...valid,
      title: validation[0],
      mobile: validation[1],
      tell1: true,
      tell2: true,
      // tell1: validation[2],
      // tell2: validation[3],
      user_mobile: validation[4]
    });
    console.log(
      "balidate",
      tellPattern.test(otherInfo?.tell1),
      validation[0],
      validation[1],
      validation[2],
      validation[3],
      validation[4]
    );
    return (
      validation[0] &&
      validation[1] &&
      validation[2] &&
      validation[3] &&
      validation[4]
    );
  };
  const showUser = () => {
    let x = [];
    x = userOptions.filter(v => v.value == otherInfo?.main_admin_uid);
    return x;
  };

  console.log("otherInfo ssssssssssss l", otherInfo);
  return (
    <>
      <div
        class="modal fade add-campain modalSupplier"
        id={`exampleModalE`}
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        dir="rtl"
        style={{ backgroundColor: "rgba(1,1,1,0.5)" }}
      >
        <div className="modal-dialog modal-fullscreen p-4">
          <div className="modal-content">
            <div className="modal-header ">
              <h5 className="modal-title" id="edit-userLabel">
                ویرایش کسب و کار
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="shop-setting d-flex justify-content-center">
                <form className="w-100 d-flex flex-column align-items-center">
                  <div className="w-100">
                    <div className="row align-items-baseline mb-3">
                      <label
                        htmlFor="shop-title"
                        className=" col-12 col-sm-3"
                        style={{ margin: "auto" }}
                      >
                        نام فروشگاه
                      </label>
                      <div className="col-12 col-sm-9">
                        {/* <input
                type="text"
                id="shop-title"
                style={{background:"#ddd"}}
                className={`form-control gray-input ${title.hasError ? " invalid" : ""}`}
                value={title.value}
                onChange={title.changeHandler}
                onBlur={title.blurHandler}
              /> */}
                        <input
                          style={{ background: "#ddd" }}
                          type="text"
                          id="shop-title"
                          name="title"
                          className="form-control"
                          value={otherInfo?.title}
                          onChange={inputChangeHandler}
                        />
                        {!valid.title && (
                          <p className="validate-text">
                            {" "}
                            نام فروشگاه نمیتواند خالی باشد.
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="row align-items-baseline mb-3">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="shop-mobile"
                        className="form-label col-12 col-sm-3"
                      >
                        دسته بندی
                      </label>
                      <div className="col-12 col-sm-9">
                        <select
                          name="main_cat"
                          class="form-select form-select-sm"
                          aria-label=".form-select-sm example"
                          style={{
                            background: "#ddd",
                            direction: "rtl",
                            padding: "9px"
                          }}
                          value={otherInfo?.main_cat}
                          onChange={inputChangeHandlerDaste}
                        >
                          {allLeader?.map((value, index) => (
                            <option key={index} value={index}>
                              {value}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="row align-items-baseline mb-2">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="shop-leastOrders"
                        className="form-label col-12 col-sm-3"
                      >
                        حداقل سفارش
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          style={{ background: "#ddd" }}
                          type="text"
                          id="shop-leastOrders"
                          name="min_order_amount"
                          className="form-control"
                          value={addCommas(otherInfo?.min_order_amount)}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    {/* کاربر */}
                    <div className="row align-items-baseline mb-3">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="user"
                        className="form-label col-12 col-sm-3"
                      >
                        کاربر
                      </label>
                      <div className="col-12 col-sm-9">
                        <Select
                          className=" filterSelect "
                          id="user"
                          options={userOptions}
                          value={showUser()}
                          onChange={e => {
                            setOtherInfo(prev => {
                              return { ...prev, main_admin_uid: e.value };
                            });

                            if (e.value == "-1") {
                              setDisplayStatusUser("d-block");
                            } else {
                              setDisplayStatusUser("d-none");
                            }
                          }}
                        />
                      </div>
                    </div>
                    {/* ایجاد کاربر جدید */}
                    <div
                      className={`d-flex ${displayStatusUser} rounded`}
                      style={{ border: "1px dashed lightgray" }}
                    >
                      <div className="w-50 p-1">
                        <label>نام کاربر</label>
                        <input
                          className="form-control"
                          type="text"
                          name="fullname"
                          value={otherInfo?.fullname}
                          onChange={inputChangeHandler}
                        ></input>
                      </div>
                      <div className="w-50 p-1">
                        <label>موبایل کاربر</label>
                        <NumericFormat
                          displayType="input"
                          id="shop-tell1"
                          allowLeadingZeros
                          className="form-control"
                          name="user_mobile"
                          value={otherInfo?.user_mobile}
                          onChange={inputChangeHandler}
                        />
                        {!valid.user_mobile && (
                          <p className="validate-text">
                            شماره وارد شده صحیح نیست.
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="row align-items-baseline mb-3">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="shop-main_admin_uid"
                        className="form-label col-12 col-sm-3"
                      >
                        لاین
                      </label>
                      <div className="col-12 col-sm-9">
                        <Select
                          id="tags"
                          className=" filterSelect "
                          options={test}
                          placeholder="لطفا لاین را انتخاب کنید"
                          // {
                          //   test.length > 0 ? (
                          //     <div> لطفا لاین را انتخاب کنید</div>
                          //   ) : (
                          //     <div> دسته بندی را انتخاب کنید</div>
                          //   )
                          // }
                          value={otherInfo?.line_ids}
                          onChange={changeHandleraTags}
                          isMulti={true}
                          style={{ background: "#ddd" }}
                          // value={defaultTags}
                        />
                      </div>
                    </div>

                    {/* <div className="row align-items-baseline mb-3">
                      <label
                        className=" col-12 col-sm-3 "
                        style={{ margin: "auto" }}
                      >
                        ساعت کار فروشگاه
                      </label>
                      <div className="col-12 col-sm-9 row align-items-baseline justify-content-between p-0 m-0">
                        <div className="col-12">
                          <input
                            style={{ background: "#ddd" }}
                            type="time"
                            id="shop-startTime"
                            name="startTime"
                            className="form-control"
                            value={`${otherInfo?.start_hour}:${otherInfo?.start_min}`}
                            onChange={(e) => {
                              changeHandler("start", e.target.value);
                            }}
                            // value={otherInfo?.startTime}
                            // onChange={inputChangeHandler}
                          />
                        </div>
                        <label
                          className="form-label  text-center"
                          style={{ margin: "auto" }}
                        >
                          الی
                        </label>
                        <div className="col-12">
                          <input
                            style={{ background: "#ddd" }}
                            type="time"
                            id="shop-endTime"
                            name="endTime"
                            className="form-control"
                            value={`${otherInfo?.finish_hour}:${otherInfo?.finish_min}`}
                            onChange={(e) => {
                              changeHandler("finish", e.target.value);
                            }}
                            //   value={otherInfo?.endTime}
                            //   onChange={inputChangeHandler}
                          />
                        </div>
                      </div>
                    </div> */}

                    <div className="row align-items-baseline mb-3">
                      <label
                        className=" col-12 col-sm-3 "
                        style={{ margin: "auto" }}
                      >
                        آپلود جواز کسب و کار
                      </label>
                      <div className="col-12 col-sm-9 row align-items-baseline justify-content-between p-0 m-0">
                        <div className="col-12">
                          <input
                            className="form-control"
                            type="file"
                            style={{ background: "#ddd" }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row align-items-baseline mb-3">
                      <label
                        className=" col-12 col-sm-3 "
                        style={{ margin: "auto" }}
                      >
                        نقشه
                      </label>
                      <div className="col-12 col-sm-9 row align-items-baseline justify-content-between p-0 m-0">
                        <div className="col-12">
                          <div className="pd-x-4 my-2">
                            <MapIR
                              location={location}
                              height={138}
                              setAddress={setAddress}
                              setLocation={setLocation}
                              setNextstep={setNextstep}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row align-items-baseline mb-3">
                      <label
                        className=" col-12 col-sm-3 "
                        style={{ margin: "auto" }}
                      >
                        ساعت شیفت کاری
                      </label>
                      <div className="col-12 col-sm-9 row align-items-baseline justify-content-between p-0 m-0">
                        <div className="col-12">
                          {/* شیفت کاری */}
                          <input
                            className="form-control"
                            type="file"
                            style={{ background: "#ddd" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
                <form className="w-100 d-flex flex-column align-items-center form2">
                  <div className="w-100">
                    <div className="row align-items-baseline mb-3">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="shop-address"
                        className="form-label col-12 col-sm-3"
                      >
                        آدرس
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          style={{ background: "#ddd" }}
                          type="text"
                          id="shop-address"
                          name="address"
                          className="form-control"
                          value={otherInfo?.address}
                          onChange={inputChangeHandler}
                        />
                      </div>
                    </div>

                    <div className="row align-items-baseline mb-3">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="shop-description"
                        className="form-label col-12 col-sm-3"
                      >
                        توضیحات
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          style={{ background: "#ddd" }}
                          type="text"
                          id="shop-description"
                          name="description"
                          className="form-control"
                          value={otherInfo?.description}
                          onChange={inputChangeHandler}
                        />
                      </div>
                    </div>

                    <div className="row align-items-baseline mb-3">
                      <label
                        htmlFor="shop-cover_file_id_edit"
                        className="form-label col-12 col-sm-3"
                        style={{ margin: "auto" }}
                      >
                        لوگو
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          onChange={changeHandlerImg}
                          style={{ background: "#ddd" }}
                          ref={inputRef}
                          name="cover_file_id"
                          className="form-control"
                          type="file"
                          id="shop-cover_file_id_edit"
                          accept="image/*"
                        />
                      </div>
                    </div>
                    <div className="row align-items-baseline mb-3">
                      <label
                        htmlFor="shop-logo_file_id_edit"
                        className="form-label col-12 col-sm-3"
                        style={{ margin: "auto" }}
                      >
                        کاور
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          onChange={changeHandlerImg}
                          style={{ background: "#ddd" }}
                          ref={inputRef}
                          name="logo_file_id"
                          className="form-control"
                          type="file"
                          id="shop-logo_file_id_edit"
                          accept="image/*"
                        />
                      </div>
                    </div>

                    <div className="row align-items-baseline mb-3">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="shop-tell1"
                        className="form-label col-12 col-sm-3"
                      >
                        تلفن
                      </label>
                      <div className="col-12 col-sm-9">
                        <NumericFormat
                          displayType="input"
                          style={{ background: "#ddd", direction: "rtl" }}
                          id="shop-tell1"
                          allowLeadingZeros
                          name="tell1"
                          className="form-control"
                          value={otherInfo?.tell1}
                          onChange={() => inputChangeHandler}
                        />
                        {!valid.tell1 && (
                          <p className="validate-text">
                            شماره وارد شده صحیح نیست.
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="row align-items-baseline mb-3">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="shop-tell2"
                        className="form-label col-12 col-sm-3"
                      >
                        تلفن 2
                      </label>
                      <div className="col-12 col-sm-9">
                        <NumericFormat
                          displayType="input"
                          style={{ background: "#ddd", direction: "rtl" }}
                          id="shop-tell2"
                          allowLeadingZeros
                          name="tell2"
                          className="form-control"
                          value={otherInfo?.tell2}
                          onChange={() => inputChangeHandler}
                        />
                        {!valid.tell2 && (
                          <p className="validate-text">
                            شماره وارد شده صحیح نیست.
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="row align-items-baseline mb-3">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="shop-mobile"
                        className="form-label col-12 col-sm-3"
                      >
                        موبایل
                      </label>
                      <div className="col-12 col-sm-9">
                        <NumericFormat
                          displayType="input"
                          decimalScale={3}
                          allowLeadingZeros
                          style={{ background: "#ddd", direction: "rtl" }}
                          id="shop-mobile"
                          name="mobile"
                          className="form-control"
                          value={otherInfo?.mobile}
                          onChange={inputChangeHandler}
                        />

                        {!valid.mobile && (
                          <p className="validate-text">
                            شماره وارد شده صحیح نیست.
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="row align-items-baseline mb-3">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="shop-email"
                        className="form-label col-12 col-sm-3"
                      >
                        ایمیل
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          style={{ background: "#ddd" }}
                          type="text"
                          id="shop-email"
                          name="email"
                          className="form-control"
                          value={otherInfo?.email}
                          onChange={inputChangeHandler}
                        />
                      </div>
                    </div>
                    <div className="row align-items-baseline mb-3">
                      <label
                        htmlFor="shop-site"
                        className=" col-12 col-sm-3"
                        style={{ margin: "auto" }}
                      >
                        وبسایت
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          style={{ background: "#ddd" }}
                          type="text"
                          id="shop-site"
                          name="site"
                          className="form-control"
                          value={otherInfo?.site}
                          onChange={inputChangeHandler}
                        />
                      </div>
                    </div>
                    <div className="row align-items-baseline mb-3">
                      <label
                        htmlFor="shop-instagram"
                        className=" col-12 col-sm-3"
                        style={{ margin: "auto" }}
                      >
                        اینستاگرام
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          style={{ background: "#ddd" }}
                          type="text"
                          id="shop-instagram"
                          name="instagram"
                          className="form-control"
                          value={otherInfo?.instagram}
                          onChange={inputChangeHandler}
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div
                style={{
                  background: "#668cd9",
                  width: "200px",
                  height: "50px",
                  color: "white",
                  padding: "7px",
                  textAlign: "center",
                  borderRadius: "7px 7px 0px 0px",
                  fontSize: "18px",
                  fontWeight: "bold"
                }}
              >
                اطلاعات بانکی
              </div>
              <div
                style={{
                  backgroundColor: "#668cd9",
                  width: "100%",
                  height: "100%",
                  color: "white",
                  borderRadius: "7px 0px 7px 7px"
                }}
              >
                {/*<div className="row p-3">*/}
                <Row className="d-flex flex-column justify-content-center ">
                  <Col xs={10} md={7} className="mx-auto mt-4">
                    <Col
                      className="d-flex mb-1"
                      htmlFor="nameBank"
                      style={{
                        whiteSpace: "nowrap"
                      }}
                    >
                      نام بانک{" "}
                    </Col>

                    <Col>
                      <input
                        style={{ background: "#ddd" }}
                        type="text"
                        id="nameBank"
                        name="nameBank"
                        className="form-control"
                        value={infoBank.nameBank}
                        onChange={e => {
                          setInfoBank({
                            ...infoBank,
                            nameBank: e.target.value
                          });
                        }}
                      />
                      {!infoBankValid.nameBank && (
                        <p className="validate-text">
                          {" "}
                          لطفا نام بانک را وارد کنید.
                        </p>
                      )}
                    </Col>
                  </Col>

                  <Col xs={10} md={7} className="mx-auto mt-2">
                    <Col
                      className="d-flex mb-1"
                      htmlFor="nameBank"
                      style={{
                        whiteSpace: "nowrap"
                      }}
                    >
                      شماره حساب{" "}
                    </Col>

                    <Col>
                      <NumericFormat
                        dir="ltr"
                        displayType="input"
                        style={{ background: "#ddd" }}
                        id="accountNumber"
                        name="accountNumber"
                        className="form-control"
                        value={infoBank.accountNumber}
                        onChange={e => {
                          setInfoBank({
                            ...infoBank,
                            accountNumber: e.target.value
                          });
                        }}
                      />
                    </Col>
                  </Col>

                  <Col xs={10} md={7} className="mx-auto mt-2">
                    <Col
                      className="d-flex mb-1"
                      htmlFor="shomare"
                      style={{
                        whiteSpace: "nowrap"
                      }}
                    >
                      شماره کارت{" "}
                    </Col>

                    <Col>
                      <PatternFormat
                        dir="ltr"
                        displayType="input"
                        style={{ background: "#ddd" }}
                        format="#### - #### - #### - ####"
                        id="numberCart"
                        name="numberCart"
                        className="form-control"
                        value={infoBank.numberCart}
                        onChange={e => {
                          // let value = e.target.value.replace(" " ,"");
                          // value = value.replace("-","");
                          setInfoBank({
                            ...infoBank,
                            numberCart: e.target.value
                          });
                        }}
                      />
                      {!infoBankValid.numberCart && (
                        <p className="validate-text">
                          لطفا شماره کارت را به درستی وارد کنید.
                        </p>
                      )}
                    </Col>
                  </Col>

                  <Col xs={10} md={7} className="mx-auto mt-2">
                    <Col
                      className="d-flex mb-1"
                      htmlFor="shomare"
                      style={{
                        whiteSpace: "nowrap"
                      }}
                    >
                      شماره شبا{" "}
                    </Col>

                    <Col>
                      <PatternFormat
                        dir="ltr"
                        displayType="input"
                        style={{ background: "#ddd" }}
                        id="Shebanumber"
                        name="Shebanumber"
                        placeholder="IR"
                        format="IR ###### ###### ###### ######"
                        className="form-control"
                        value={infoBank.Shebanumber}
                        onChange={e => {
                          setInfoBank({
                            ...infoBank,
                            Shebanumber: e.target.value
                          });
                        }}
                      />

                      {!infoBankValid.Shebanumber && (
                        <p className="validate-text">
                          لطفا شماره شبا را به درستی وارد کنید.
                        </p>
                      )}
                    </Col>
                  </Col>

                  <Col
                    className="mx-auto my-2"
                    style={{
                      width: "90px",
                      backgroundColor: "#eb4b97",
                      borderRadius: "17px",
                      padding: "5px 11px",
                      textAlign: "center",
                      cursor: "pointer",
                      color: "white",
                      fontSize: "17px"
                    }}
                    onClick={() => {
                      console.log(
                        "ok lcick: ",
                        InfoBankValidation(),
                        " ",
                        infoBankValid
                      );
                      if (InfoBankValidation()) {
                        setInfoBank({
                          numberCart: "",
                          nameBank: "",
                          Shebanumber: "",
                          accountNumber: ""
                        });

                        console.log("ok lcick: ");
                        setListInfoBank(prev => {
                          let temp = [...prev];
                          return [...temp, { ...infoBank, checked: true }];
                        });
                      }
                    }}
                  >
                    <div className="justify-content-between">
                      <span style={{ marginLeft: "7px" }}>
                        <MdFileDownloadDone></MdFileDownloadDone>
                      </span>
                      <span>ثبت</span>
                    </div>
                  </Col>
                </Row>
              </div>
              <div
                class="tab-pane fade show active"
                id="v-pills-home"
                role="tabpanel"
                aria-labelledby="v-pills-home-tab"
                style={{ margin: "12px" }}
              >
                {listInfoBank.length > 0 ? (
                  <>
                    {listInfoBank?.map((value, index) => {
                      return (
                        <div
                          key={index}
                          className="d-flex flex-row px-3 my-3 mx-12 text-center text-md-start"
                          style={{
                            border: "2px solid #A7A9D6",
                            borderRadius: "10px"
                            // width: "48%",
                          }}
                        >
                          <div
                            className="form-check form-switch"
                            style={{ paddingTop: "13px" }}
                          >
                            <input
                              className="form-check-input"
                              name="checked"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckChecked"
                              onChange={event => {
                                event.persist();
                                setListInfoBank(prev => {
                                  let temp = [...prev];
                                  temp[index].checked = event.target.checked;

                                  return temp;
                                });
                              }}
                              checked={listInfoBank[index].checked}
                            />
                          </div>

                          <div className="d-flex flex-column justify-content-around w-100">
                            <div className="d-flex flex-column justify-content-between flex-wrap ">
                              <div className="d-flex flex-row justify-content-between flex-wrap my-3">
                                <div>
                                  <div className="d-xl-flex-row justify-content-between">
                                    <div>شماره کارت : {value.numberCart}</div>
                                    <div>نام بانک : {value.nameBank}</div>
                                  </div>
                                  <div>
                                    شماره حساب:{" "}
                                    {value.accountNumber
                                      ? value.accountNumber
                                      : ""}
                                  </div>
                                  <div>شماره شبا: {value.Shebanumber}</div>
                                </div>
                                <div className="d-flex ">
                                  <div>
                                    <h4 data-tip="حذف ">
                                      <RiDeleteBin5Line
                                        className="tlg1"
                                        onClick={() => RemoveInfoBank(index)}
                                      />
                                    </h4>
                                    <ReactTooltip />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </>
                ) : (
                  ""
                )}
              </div>
              <div className="mt-4 mx-3">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="flexCheckDefault"
                  />
                  <label class="form-check-label" for="flexCheckDefault">
                    تایید اطلاعات
                  </label>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                ref={inputElement}
              >
                بستن
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  console.log("balidate", validate(), valid);
                  if (validate()) {
                    postHandler(otherInfo);
                  }
                }}
                disabled={disabledBtn}
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditSupplier;
